import api from "../api";


export const getWhitelistItems = async () => {
  try {
    const response = await api.get("mivulite/whitelist");
    return response.data;
  } catch (error) {
    console.error("Error fetching whitelist:", error);
    throw error;
  }
};


export const addToWhitelist = async (data) => {
  try {
    const response = await api.post("mivulite/whitelist", data);
    return response.data;
  } catch (error) {
    console.error("Error adding to whitelist:", error);
    throw error;
  }
};


export const bulkAddToWhitelist = async (data) => {
  try {
    const response = await api.post("mivulite/whitelist/bulk-add", data);
    return response.data;
  } catch (error) {
    console.error("Error bulk adding to whitelist:", error);
    throw error;
  }
};

export const exportWhitelist = async () => {
  try {
    const response = await api.get("mivulite/whitelist/export");
    return response.data;
  } catch (error) {
    console.error("Error exporting whitelist:", error);
    throw error;
  }
};


export const importWhitelist = async (data) => {
  try {
    const response = await api.post("mivulite/whitelist/import", data);
    return response.data;
  } catch (error) {
    console.error("Error importing whitelist:", error);
    throw error;
  }
};

export const removeFromWhitelist = async (mac) => {
  try {
    const response = await api.delete(`mivulite/whitelist/${mac}`);
    return response.data;
  } catch (error) {
    console.error("Error removing from whitelist:", error);
    throw error;
  }
};

export const deleteWhitelistItem = removeFromWhitelist;